export enum UploadStatus {
  NOT_FOUND = 'not_found',
  SCHEDULED = 'scheduled',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  INVALID_ID = 'invalid_id',
  ERROR = 'error',
}
